import { TRESPONSE_FETCH_LIBRARY_METHODS } from '@monorepo/types';

export const FETCH_LIBRARY_METHODS_MOCK: TRESPONSE_FETCH_LIBRARY_METHODS = {
  data: [
    {
      id: 'method-001',
      code: 'M-2024-001',
      status: 'COMPLETED',
      tstValue: 35.5,
      samValue: 0.59,
      productTypeName: 'T-Shirt',
      operationName: 'Side Seam Joining',
      partName: 'Body',
      machineName: 'Single Needle Lock Stitch',
    },
    {
      id: 'method-002',
      code: 'M-2024-002',
      status: 'COMPLETED',
      tstValue: 28.0,
      samValue: 0.47,
      productTypeName: 'Trouser',
      operationName: 'Inseam Joining',
      partName: 'Leg',
      machineName: 'Double Needle Lock Stitch',
    },
    {
      id: 'method-003',
      code: 'M-2024-003',
      status: 'DRAFT',
      tstValue: 42.0,
      samValue: 0.7,
      productTypeName: 'Jacket',
      operationName: 'Collar Attach',
      partName: 'Collar',
      machineName: 'Feed Off the Arm',
    },
    {
      id: 'method-004',
      code: 'M-2024-004',
      status: 'COMPLETED',
      tstValue: 18.5,
      samValue: 0.31,
      productTypeName: 'T-Shirt',
      operationName: 'Label Attach',
      partName: 'Neck',
      machineName: 'Single Needle Lock Stitch',
    },
    {
      id: 'method-005',
      code: 'M-2024-005',
      status: 'DRAFT',
      tstValue: 55.0,
      samValue: 0.92,
      productTypeName: 'Trouser',
      operationName: 'Waistband Attach',
      partName: 'Waistband',
      machineName: 'Double Needle Lock Stitch',
    },
  ],
  paginationInfo: {
    totalPageCount: 3,
    itemsPerPage: 5,
    totalItems: 14,
    rangeInPage: { start: 1, end: 5 },
  },
  filters: [
    {
      key: 'product_type',
      values: [
        'SINGLE JERSEY',
        'SHORTS',
        'LEGGING',
        'T-SHIRT',
        'JACKET',
        'JOGGERS',
        'TROUSER',
        'PANT',
        'BOTTOM',
        'OTHERS',
        'SLEEPER WEAR',
        'JACKETS',
        'LADIES TOP',
        'DRESS',
        'PYJAMA',
        'JERSY',
        'SHIRT',
      ],
      displayName: 'product_type',
    },
    {
      key: 'buyer',
      values: [
        'TEXPORT_B6',
        'TESTBUYER GAMMA',
        'TOMMY HILFIGER',
        'B3131',
        'MICHAEL KORS',
        'SHAMS STYLING WEARS LTD',
        '3 PROCESSMAPPING',
        'U_B2',
        'U_B1',
        'NAUTICA-ABG-LF',
        'B1332',
        'U_B4',
        'TEXPORT_B7',
        'B3132',
        '1B21',
        'TEXPORT INDUSTRIES PVT LTD(BLR)',
        'U_B3',
        'ORDERDISMISS_B07',
        'CHARLES RIVER APPAREL',
        'SOFT SURROUNDINGS',
        'LEVI STRAUSS GLOBAL TRADING CO. LTD',
        'LC WAIKIKI MAGAZACILIK HIZM TIC A.S',
        'TESTBUYER ALPHA',
        '4 NONBREAKING',
        'PROCESSMAPPING',
        'LEVI STRAUSS INDIA PVT LTD',
        'CLEANBUYER',
        'TODD SNYDER INC',
        '4 NON BREAKING',
        'TESTBUYER DELTA',
        'BIMINI BAY OUTFITTERS',
        'STANCE',
        'TESTBUYER BETA',
        '6 NON BREAKING',
        'KOHL’S INC.',
        'LUCKY BRAND DUNGAREES LLC',
        'BUYER 1',
        'AMERICAN EAGLE',
        'TESTBUYER CLEAN',
        '3 NONBREAKING',
        'TEST',
        'DELTA GALIL INC',
        'WAL MART INC',
        '4 PROCESSMAPPING',
        'PROCESSMAPPING ',
        'LF MEN`S GROUP LLC (LANDS` END)',
      ],
      displayName: 'buyer',
    },
    {
      key: 'season',
      values: [
        'SN161',
        'ORDERDISMISS_SE7',
        'SPRING 2026',
        'BTS-2025',
        'SPRING 2024',
        'SE06',
        'SPRING-26',
        'FALL2026',
        'H1-24',
        'SN16',
        'TRANS-25',
        'SEASON 1',
        'SPRING-25',
        'H1-25',
        'FALL-25',
        'H2-24',
        'SEASON1 ',
        'SUMMER 25',
        'SEASON2',
        'SPRING2026',
        'SUMMER',
        'H2-25',
        'SPRING-SUMMER-25',
        'SN',
        '3131',
        'WINTER2026',
        'SEASON 1',
        'SEASON3',
        'FH-24',
        'SEASON',
        'SS-25',
        'SUMMER 2023',
        'SEASON1',
        'HOLIDAY-2025',
        'SE07',
      ],
      displayName: 'season',
    },
    {
      key: 'tna_status',
      values: ['IN PROGRESS', 'INCOMPLETE', 'NOT STARTED', 'UNASSIGNED'],
      displayName: 'TNA Status',
    },
    {
      key: 'po',
      values: ['P01', 'P02', 'PO205', 'P05', 'P04', 'P 03', 'PO201', 'PO202', 'PO203', 'PO204'],
      displayName: 'po',
    },
    {
      key: 'order_status',
      values: ['NOT STARTED', 'COMPLETED', 'IN PROGRESS'],
      displayName: 'Order Status',
    },
    {
      key: 'erp',
      values: [
        'BLRW/007734.1',
        'BLRK/005880.1',
        'BLRW/008108.1',
        'BLRW/007909.1',
        'BLRW/008303.1',
        'BLRK/005788.1',
        'BLRW/007526.1',
        'BLRK/005885.1',
        'BLRW/007623.1',
        'BLRW/008067.1',
        'OCS1',
        'BLRW/007901.1',
        'BLRK/005867.1',
        'BLRW/007683.1',
        'BLRK/005767.1',
        'BLRK/005876.1',
        'BLRW/008016.1',
        'BLRW/007769.1',
        'BLRW/007666.1',
        'BLRW/007622.1',
        'BLRK/005641.1',
        'OCS10',
        'BLRK/005886.1',
        'BLRK/005865.1',
        'BLRW/008049.1',
        'BLRK/005904.1',
        'BLRW/007967.1',
        'BLRW/008065.1',
        'BLRW/008073.1',
        'BLRW/007363.1',
        'BLRW/007793.1',
        'BLRW/002345.1',
        'BLRW/008224.1',
        'BLRW/008018.1',
        'BLRW/007468.1',
        'OC101',
        'OC8',
        'BLRW/007931.1',
        'BLRW/008056.1',
        'BLRK/005863.1',
        'BLRW/007790.1',
        'BLRK/005844.1',
        'BLRW/007568.1',
        'BLRK/005854.1',
        'OCS11',
        'BLRW/007789.1',
        'BLRW/008066.1',
        'BLRK/005871.1',
        'BLRK/005858.1',
        'BLRW/007900.1',
        'BLRK/005905.1',
        'BLRW/007522.1',
        'BLRW/007753.1',
        'BLRW/007966.1',
        'BLRK/005714.1',
        'BLRK/005845.1',
        'BLRW/007905.1',
        'BLRW/008421.1',
        'BLRW/008415.1',
        'OCS007',
        'OCS2',
        'BLRW/008211.1',
        'BLRK/005846.1',
        'BLRK/005654.1',
        'BLRW/008057.1',
        'BLRW/008075.1',
        'BLRW/007903.1',
        'BLRW/007842.1',
        'BLRW/008058.1',
        'BLRK/005632.1',
        'BLRW/007688.1',
        'BLRW/008223.1',
        'BLRK/005768.1',
        'BLRK/005648.1',
        'BLRW/007964.1',
        'BLRW/008059.1',
        'BLRK/005784.1',
        'BLRW/008106.1',
        'BLRW/007914.1',
        'BLRW/007767.1',
        'BLRW/008004.1',
        'BLRW/007626.1',
        'BLRW/008061.1',
        'BLRW/007920.1',
        'BLRK/005652.1',
        'BLRK/005892.1',
        'BLRW/007965.1',
        'BLRW/007764.1',
        'BLRW/008078.1',
        'BLRK/005536.1',
        'BLRW/008414.1',
        'OC13',
        'BLRK/005649.1',
        'BLRW/007692.1',
        'BLRW/007773.1',
        'BLRW/007612.1',
        'BLRW/008423.1',
        'BLRK/005888.1',
        '1234',
        'BLRK/005869.1',
        'BLRW/007706.1',
        'BLRW/007786.1',
        'BLRW/007475.1',
        'BLRK/005862.1',
        'BLRK/005799.1',
        'BLRW/007361.1',
        'BLRW/008070.1',
        'BLRW/007716.1',
        'BLRK/005549.1',
        'BLRW/007902.1',
        'BLRW/007966.2',
        'BLRK/005907.1',
        'BLRK/005642.1',
        'BLRK/005887.1',
        'BLRW/007762.1',
        'BLRK/005658.1',
        'BLRK/005864.1',
        'BLRK/005555.1',
        'BLRK/005550.1',
        'BLRK/004871.1',
        'BLRK/004869.1',
        'BLRW/007754.1',
        'BLRW/007941.1',
        'OCS14',
        'OC7',
        'BLRK/005817.1',
        'BLRK/005894.1',
        'BLRW/007763.1',
        'BLRW/007907.1',
        'BLRK/005539.1',
        'BLRW/008010.1',
        'BLRW/007832.1',
        'BLRW/007530.1',
        'BLRW/007871.1',
        'BLRK/005855.1',
        'BLRW/007756.1',
        'BLRK/005636.1',
        'BLRK/005797.1',
        'BLRW/008015.1',
        'BLRW/008077.1',
        'BLRW/007844.1',
        'BLRW/007563.1',
        'BLRK/005708.1',
        'BLRW/007904.1',
        'BLRK/005872.1',
        'BLRW/007765.1',
        'BLRK/005796.1',
        'BLRW/007758.1',
        'DOCS7',
        'BLRW/007926.1',
        'BLRK/005873.1',
        'BLRK/005889.1',
        'BLRK/005851.1',
        'BLRK/005875.1',
        'BLRW/008042.1',
        'BLRW/007715.1',
        'OCS12',
        'BLRW/008064.1',
        'BLRW/007792.1',
        'BLRK/005908.1',
        'BLRW/007457.1',
        'BLRW/007525.1',
        'BLRK/005884.1',
        'BLRK/005891.1',
        'BLRW/007358.1',
        'BLRK/005659.1',
        'BLRK/005795.1',
        'BLRW/007924.1',
        'BLRW/007537.1',
        'BLRK/005903.1',
        'BLRW/007919.1',
        'BLRW/007329.1',
        'OC2',
        'OCS4',
        'BLRK/005874.1',
        'BLRK/004873.1',
        'BLRK/005861.1',
        'BLRW/007807.1',
        'BLRW/007916.1',
        'BLRK/005787.1',
        'BLRK/004872.1',
        'BLRW/001234.1',
        'BLRW/007359.1',
        'BLRW/008051.1',
        'BLRK/006330.1',
        'BLRK/005656.1',
        'BLRW/007785.1',
        'BLRW/007584.1',
        'BLRK/005879.1',
        'OC5',
        'BLRW/008424.1',
        'BLRW/007989.1',
        'BLRW/007505.1',
        'BLRW/008071.1',
        'BLRW/007835.1',
        'BLRK/005847.1',
        'BLRK/005890.1',
        'BLRW/007667.1',
        'BLRW/008147.1',
        'BLRW/007774.1',
        'BLRW/007777.1',
        'BLRW/003131.1',
        'BLRK/005870.1',
        'BLRW/007968.1',
        'BLRW/007929.1',
        'BLRW/007521.1',
        'BLRW/007845.1',
        'BLRK/005713.1',
        'BLRW/008063.1',
        'BLRW/008109.1',
        'BLRK/005866.1',
        'BLRW/008152.1',
        'BLRW/007536.1',
        'BLRW/008076.1',
        'BLRW/007519.1',
        'BLRW/007925.1',
        'BLRK/005639.1',
        'BLRK/005902.1',
        'BLRW/007795.1',
        'BLRW/007870.1',
        'BLRW/008026.1',
        'BLRW/008027.1',
        'BLRK/005882.1',
        'BLRW/008069.1',
        'BLRW/008072.1',
        'BLRK/005785.1',
        'BLRK/005883.1',
        'BLRK/005860.1',
        'BLRW/007908.1',
        'BLRK/005722.1',
        'BLRW/008074.1',
        'BLRW/008011.1',
        'OCS006',
        'BLRK/005638.1',
        'BLRW/007478.1',
        'BLRK/005881.1',
        'BLRW/008014.1',
        'BLRK/005897.1',
        'BLRW/008025.1',
        'BLRW/008062.1',
        'BLRW/008416.1',
        'BLRW/008000.1',
        'BLRK/005857.1',
        'BLRK/005793.1',
        'BLRW/007963.1',
        'BLRK/005859.1',
        'BLRW/008420.1',
        'BLRK/005850.1',
        'BLRW/007948.1',
        'BLRK/005725.1',
        'BLRW/007529.1',
        'BLRK/005794.1',
        'BLRK/005899.1',
        'BLRK/005848.1',
        'BLRW/007770.1',
        'OCS13',
        'BLRK/005472.1',
        'BLRK/005634.1',
        'BLRW/008060.1',
        'BLRW/007898.1',
        'BLRW/007771.1',
        'BLRW/008139.1',
        'BLRW/007741.1',
        'BLRW/007788.1',
        'OCS5',
        'BLRK/005906.1',
        'BLRW/008068.1',
        'BLRW/007856.1',
        'BLRW/007855.1',
        'OCS3',
        'BLRW/007854.1',
        'BLRK/005849.1',
        'BLRW/007473.1',
        'BLRW/008053.1',
      ],
      displayName: 'erp',
    },
    {
      key: 'planned_status',
      values: ['NOT PLANNED', 'COMPLETELY PLANNED', 'PARTIALLY PLANNED'],
      displayName: 'Planned Status',
    },
    {
      key: 'type_of_order',
      values: ['CONFIRMED', 'PROVISIONAL'],
      displayName: 'Type Of Order',
    },
    {
      key: 'style',
      values: [
        '23771-0051-0097 REPEAT NOV MONTH',
        'CORE FLARE PANTS',
        'CS5304ZDR2',
        '148073..',
        'MS53W120RR1',
        'TS2',
        'TEXPORT_S7',
        'XW0XW04311 -W SS GINGHAM SHIRT DRESS- SPRING 2025',
        'T7078JB100 M TOMMY STR OG OX GINGHAM SS RGF FALL 2025',
        '91010V MENS V NECK TEE',
        '2GW60',
        'WEEKEND BOXY SWEATSHIRT',
        'MS51W310RP',
        'XW0XW06870 - OP W LINEN BLEND LS SHIRT-SPRING-26',
        '6193',
        'T7076J5521 - W LS RELAXED STRIPE SHIRT - SPRING 2025',
        'T7076J5094 -- W S/S MANGO SLIM ZIP NECK POLO DRESS....',
        'MS41W100RR10 PSP25',
        '135032',
        '76J4883-W S/S CREW NEW FAVE CORE PLUS-13/09/2024',
        '2GV61',
        'XM0XM05553 KOHL BIG GING BRUSHED LS RGF FALL 2025',
        'XG0XG01536- KG TOMMY FOIL LEGGING',
        'CT52096HJQ',
        'XM0XM03566 OP RWB TIPPED PIQUE SS TEE',
        'T7071J3498 -MB LS STRETCH OG OXFORD SHIRT',
        'XG0XG01424-KG SL PRINTED RUFFLE KNIT TANK AOP 13/9/24',
        'XW0XW04844-W SS RUGBY MANGO SLIM ZIP POLO 16/4/24',
        'MS41W150RR',
        'XW0XW04844-W SS RUGBY MANGO SLIM ZIP POLO',
        'OB410091',
        '132974(7MP4777)-SUMMER25',
        'OF3034K7E',
        'CS5208LHBY TRANS 25',
        'A4040 -002BJ-0000 000100020003',
        '144543',
        'S3',
        '2GV23',
        'XW0XW07917 - LIC W IM LINEN SHIRT_RELAXED FIT -SPRING-26',
        'CLEANSTYLE',
        'XM0XM03978-M SS PLACEMENT STRIPE TEE',
        '120542.',
        '149113',
        '112236//544155-MENS ESSENTIAL SS PAJAMA SET- REGULAR',
        'XW0XW06867 - OP W HERITAGE REG FIT LS SHIRT-SPRING-26',
        'TEXPORT_S6',
        '137434',
        'K57927 SS PRINTED TILE JERSY JOHNNY COLLAR SMS',
        '155205..',
        'S10',
        'ORDERDISMISS_S07',
        'TS4',
        'XG0XG01550-KG STRIPE TEE LS',
        '137683',
        '91010V MENS CREW NECK TEE',
        'XM0XM06385 OP EXT BIG GING BRUSHED LS RGF -FALL 2025',
        'S1332',
        '160224...',
        'MS5FW150RR2',
        'A4040-002BJ-000100020003',
        '102074 MENS TALL TRADITIONAL FIT SAIL RIGGER OXFORD SHIRT 519715',
        'T7076J4871-W S/S VNK FAVE CORE',
        'XG0XG01366-KG SS RUFFLE BUTTON TOP',
        'MS41W100RR11 PSP25.',
        '138372',
        '152320-552452-PETITE- W LINEN RS RELAXED TUNIC WITH POCKETS -',
        '2FV89',
        '150802 - 551017-MTALL SAIL RIGGER SS SHIRT',
        '129114 ADDON TO SUMMER25',
        'OB4500026',
        '137420',
        '6214 CORE PERFECT SHIRT INTL YD',
        '91001V MENSS CREW NECK TEE',
        'XG0XG01356-VARSITY FITTED LEGGING',
        'WW0WW47135-1X1 RIB S/S V-NK TEE DRESS',
        'WEEKEND STRAIGHT KEG SWEATPANTS',
        'XM0XM05840 M BARBEAU OXFORD LS SF SHIRT FALL 2025',
        'XG0XG01394- KG CIRCLE LOGO FASHION LEGGING-FA-25',
        '002B2-0000',
        '2755 SS OVERSIZED CAMP COLLAR EMBROIDERED SHIRT',
        'K57916 SS SOLID KERSEY POLO WITH PKT GRAPHIC SMS',
        'TS 1',
        'T7076J3175 W L/S MANGO ZIP POLO -',
        '137426',
        '2GV10',
        'XW0XW06018-W LS JERSEY TEE SOLID',
        'XM0XM05554 KOHL KLONDIKE BRUSHED LS RGF FALL 2025',
        'CF59054K0C',
        '137909',
        'MS41W100RS20 FA25',
        'POINTELLE TOP',
        '102074 MENS- BIG/TALL TRADITIONAL FIT SAIL RIGGER OXFORD SHIRT-519704',
        'XG0XG01158-KG SEERSUCKER STRPD RUFFLE DRESS',
        '76J4887-W S/S VNK FAVE CORE FALL 25',
        'XW0XW07918 - LIC W IM LINEN SHIRT_STP RELAXED-SPRING-26',
        'BUC00023',
        'KN9020697',
        'OT4303TDR2',
        'T7076J4883-W S/S CREW NEW FAVE CORE PLUS-',
        'S1',
        'MS51W101XS- SU-25',
        '154223 (B&T)',
        '1/030S 40D - SOLID DYED - SINGLE JERSEY - 56% POLYESTER 37% SPANDEX 7% COMBED BCI - 250 GSM-NORMAL FINISH FOR DYED',
        'MS41W100RR11 FA25',
        '917587-DEFNE REP',
        '144144',
        'XW0XW06020-W LS TURTELNECK TEE',
        '003QS-0006.',
        'W56800 S/S BEACH BOYS CAMP SHIRT',
        'S2',
        '003R4-0000-PROJECTION',
        '003QS-0003.',
        '137582',
        '2GF90',
        'A4040 -002BJ-000100020003',
        '148073',
        'STYLE 1',
        'MS41W100XR14 SU 25',
        'XM0XM06393 OP EXT STERLING BRUSHED LS RGF -FALL 2025',
        'S2 ',
        'MS41W150RR- SU25',
        'MS51W155RR',
        'T7078JA566-M STRETCH SLIM FIT CREW',
        'XW0XW05029-W S/S CREW NK RUGBY STRIPE 16/9/24',
        '2958_SS CF CSC BEAN DOBBY SHIRT_SLIM FIT',
        'ABC',
        'XW0XW07919 - LIC W RELAXED FIT LINEN SHIRT SS-SPRING-26',
        'T7076J4869-W S/S CREW NEW FAVE CORE',
        'T7076J4826 - W HERITAGE REGULAR FIT SHIRT-SPRING 2025 -D3.',
        'XM0XM04707 -M FUN STRIPE OX LS RGF -SUMMER 2025',
        'OF5408M4YT',
        'S 2',
        'OB410097',
        'OB420039',
        '003K1-000-0001/0002',
        'OB420036',
        '6416 SOMCKED HANKY HEM TUBE YD',
        '76J4871-W S/S VNK FAVE CORE--25-10-24',
        '003QS-0001',
        'MS51W101RS',
        'XM0XM04901 FA-25',
        '150802 - 551010 MB SS SAIL RIGGER SHIRT',
        'S 2',
        '540089- WP LS OXFORD FAVORITE SHIRT',
        'AURA HOODIE',
        '144326',
        'XW0XW06871 - OP W LINEN BLEND STRIPE LS SHIRT -SPRING-26',
        'MS51W101XS- SP25',
        '2GV20',
        '151495 -551150 WR LINEN HR PALAZZO PANT',
        '78JA562-M STRETCH SLIM FIT CREW',
        'T7078JA562-M STRETCH SLIM FIT CREW',
        '144268',
        'XM0XM04704-MOULINEOX TIPPED SS POLO RF',
        'T7076J3796 - LIC W IM LINEN SHIRT - SPRING 2025',
        'XW0XW06868 - OP W HERITAGE STP RF LS SHIRT -SPRING-26',
        'XG0XG01371-KG SS RIBBED TSHIRT DRESS',
        'T7076J1536-W MANGO SLIM ZIP POLO-',
        'FAMWB00195SP25',
        '144336',
        'T7071J3884 -KB LS STRETCH STRIPE OG OX SHIRT',
        '78JA564-M STRETCH SLIM FIT V- 13/9/24',
        'XB0XB01572-KB NANTUCKET PLACED STRIPE TEE',
        'WW0WW45955-1X1 RIB AOP S/S V-NK TEE DRESS',
        '2517 - WOMENS',
        'XM0XM04872 OP DUNCAN BRUSHED LS RGF FALL 2025',
        '6243 - YARN DYED',
        '9278- BLACK / RED',
        'XW0XW04753 -W PUFF SS OXFORD SHIRT-STRIPE SPRING-2025',
        'MS41W150RP1',
        '129126',
        'XM0XM06210 JF BIG GING BRUSHED LS RGF FALL 2025',
        'XM0XM04873 OP KLONDIKE BRUSHED LS RGF -FALL 2025',
        'XW0XW06518-W LS TURTELNECK TEE STRIPE',
        '151654 -551533 W REG LINEN HR PO 7 SHORT',
        '137431',
        '2925 OVERSIZED CSC MAYHEM CHAMBRAY WORK SHIRT',
        'V41050-MENS ANCHOR POCKET TEE',
        '137430',
        'BJ51W102KP',
        'XM0XM04833 -M SEERSUCKER STRIPE RGF SS SHIRT -SUMMER 2025',
        'DENTI - SHORTS.',
        'XW0XW06527-W LS SOLID RIB DRESS',
        'V7310-MENS V NEK TEE',
        'XM0XM06211 -JF KLONDIKE BRUSHED LS RGF FALL 2025',
        'K57917 SS SOLID JERSEY POLO WITH LARGE GRAPHIC SMS',
        '1112',
        '003R4-0002-PROJECTION',
        'XW0XW04306 - W SS PUFF SLV SHIRT-SOLID - SPRING 2025',
        'JG52Y100RP',
        '3697 CORE INT DENIM SHIRT_SUMMER_25',
        'CS5304LHBY',
        '101770- 517124 -MR MENS TRAD FIT SS LINEN SHIRT',
        'XW0XW04969-W SS RIB BUTTON POLO.',
        '2765 SS OVERSIZED CAMP COLLAR DOBBY STRIPE SHIRT',
        'FA36013358',
        'OF5303TK81',
        'XM0XM04874 OP STERLING BRUSHED LS RGF -FALL 2025',
        'T7076J4889--W C-NK LS FAVE TEE ..',
        '6093 CORE PERFECT SHIRT INTL_REPEAT',
        'MS41W100RR10 FA25',
        'MS41W100RR11 SP25',
        '540099- WB LS OXFORD FAVORITE SHIRT',
        'XM0XM04205-M JERSEY SS SLIM POLO 16/9/24',
        'XM0XM06179 M DARROW BRUSHED PLAID LS RGF FALL-25',
        '91001V CREW NECK TEE',
        '540098A WR LS OXFORD FAVORITE SHIRT',
        'WW0WW47134-1X1 RIB SOLID S/S V-NK TEE',
        'OB450012',
        '102074 MENS REGULAR TRADITIONAL FIT SAIL RIGGER OXFORD SHIRT 519694',
        'XW0XW06019-W LS RIBBED HENLEY',
        '78JA563-M STRETCH SLIM FIT V',
        'T7076J5487-W SS MOCK NECK TEE',
        'XG0XG01544- ESSENTIAL RIB TOP',
        '2GV98',
        '5524 SOFT SEERSUCKER PANT',
        'K57921 SS VERTICAL TEXTURED BUTTON FRONT POLO',
        'MS51W211XS',
        'XM0XM04400 OP NEW WESTLY HENLEY SS.',
        'XW0XW04307 - W SS PUFF SLV SHIRT-STRIPE - SPRING 2025',
        'XM0XM03532 OP FLAG PLACKET SS POLO RF-FA25',
        '133764',
        'T7071J3499 - KB LS STRETCH OG OXFORD SHIRT',
        '150802 - 551008-MREG SAIL RIGGER SS SHIRT',
        '7MP4777-REORDER',
        'XM0XM05860 M BRUSHED CHALK LS RGF FALL-25',
        'XM0XM04471 -OP COASTAL GEO SS RGF- SUMMER 2025',
        '2GV22',
        'S5',
        'OF54086K81',
        'XG0XG01466-KG STRIPED RUFFLE TANK TOP 16/9/24',
        'XG0XG01542- ESSENTIAL RIB TOP',
        'XM0XM04828 -M TEXTURED CAMP COLLAR SS SHIRT-SUMMER 2025',
        '6302 TIE FRONT CAMI MB',
        '137954',
        '102074 MENS TRADITIONAL FIT SAIL RIGGER OXFORD SHIRT- BIG-526091',
        '2893_SS CF CSC BEAN DOBBY SHIRT',
        '127919..',
        'MS41W100XS20 FA25',
        '2FH72',
        'CT54086HVJ',
        '16960 -002BN-0000-0001-0002-0003',
        'CF54086JWX',
        'XM0XM05108 - KOHL COASTAL GEO SS RGF- SUMMER 2025',
        'STYLE 1 - 2',
        'TEST1',
        'XM0XM06386 OP EXT DUNCAN BRUSHED LS RGF -FALL 2025',
        '23771-0090-0342 REPEAT JULY MONTH',
        'T7078J0437 -BT TWAIN CHECK STRETCH LS - SUMMER 2025',
        'MS41W100XR14 SP25',
        'S3131',
        '128232-SS SLUB HENLEY-SMS',
        '3517-S24M151',
        'CS4301KDR2',
        'V41050',
        'STYLE 2',
        'S4',
        'FA36013354',
        'XM0XM05833 M DUKE OXFORD LS RGF FALL-25',
        'TS3',
        'TS5',
        'CT5304SHVS',
        '144576',
        '76J4869-W S/S CREW NEW FAVE CORE--25-10-24',
        'WW0WW46879-1X1 RIB S/S RINGER TEE',
        'XM0XM04871 OP BIG GING BRUSHED LS RG FALL 2025',
        '6183 OVERALL SCHIFFILI',
        'XW0XW06017-WW LS JERSEY TEE STRIPE',
        'MS41W100RR10 SP25',
        '137704',
      ],
      displayName: 'style',
    },
    {
      key: 'delivery_date',
      values: [],
      displayName: 'Delivery Date',
    },
    {
      key: 'factory_allocation_status',
      values: [
        {
          value: 'Unallocated',
          displayName: 'Unallocated',
        },
        {
          value: 'bgd-cl10-fac1',
          displayName: 'Factory 1',
        },
        {
          value: 'bgd-cl10-fac2',
          displayName: 'Factory 2',
        },
      ],
      displayName: 'Factory Allocation Status',
    },
  ],
  hasNonZeroEntities: true,
};
